import React from "react";

const CategoryIcon = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.58326 2.56951L3.28213 3.82974L2.0219 10.1309C2.00172 10.2318 2.00677 10.3361 2.03658 10.4346C2.0664 10.533 2.12007 10.6226 2.19282 10.6954L10.3532 18.8558C10.4112 18.9138 10.4801 18.9598 10.556 18.9912C10.6318 19.0226 10.7131 19.0388 10.7951 19.0388C10.8772 19.0388 10.9585 19.0226 11.0343 18.9912C11.1101 18.9598 11.179 18.9138 11.2371 18.8558L18.3081 11.7847C18.3662 11.7267 18.4122 11.6578 18.4436 11.5819C18.475 11.5061 18.4912 11.4248 18.4912 11.3427C18.4912 11.2607 18.475 11.1794 18.4436 11.1036C18.4122 11.0277 18.3662 10.9588 18.3081 10.9008L10.1478 2.74043C10.075 2.66768 9.98543 2.61401 9.88695 2.58419C9.78847 2.55437 9.68416 2.54933 9.58326 2.56951V2.56951Z"
      stroke="#677791"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5625 8.04761C7.08027 8.04761 7.5 7.62787 7.5 7.11011C7.5 6.59234 7.08027 6.17261 6.5625 6.17261C6.04473 6.17261 5.625 6.59234 5.625 7.11011C5.625 7.62787 6.04473 8.04761 6.5625 8.04761Z"
      fill="#677791"
    />
  </svg>
);
export default CategoryIcon;
